import { localDatabaseUrls } from "../backend/constants";
import { getAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const getLandedDashboardSkuCounts = async () => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedDashboardSkuCounts}`;

  try {
    const response = await getAPI(apiUrl, tokenInfo);
    if (response?.ok) {
      return response.json();
    }

    const errorData = response?.json ? await response.json().catch(() => ({})) : {};
    throw new Error(errorData?.message || "Unable to load dashboard SKU counts.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to load dashboard SKU counts.", {
      contactSupport: false,
    });
    return null;
  }
};

export default getLandedDashboardSkuCounts;
